import React from 'react'
import './TextEditor.css'
import Button from '../../../shared/components/ui/Button'

/**
 * 대본 텍스트 편집 컴포넌트
 */
function TextEditor({ section, editingSection, setEditingSection, onTextUpdate }) {
  const [currentText, setCurrentText] = React.useState(section.text)
  
  // section.text가 변경되면 currentText 업데이트
  React.useEffect(() => {
    setCurrentText(section.text)
  }, [section.text])
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      // 엔터 키 입력 시 저장 및 편집 모드 종료
      console.log('📝 엔터 키로 저장:', currentText)
      onTextUpdate(section.id, currentText)
      // 편집 모드 종료는 약간의 딜레이 후 실행 (저장 처리 완료 후)
      setTimeout(() => {
        setEditingSection(null)
      }, 100)
    } else if (e.key === 'Escape') {
      setEditingSection(null)
      setCurrentText(section.text) // 원래 텍스트로 복원
    }
  }

  const handleSave = () => {
    console.log('💾 저장 버튼 클릭:', currentText)
    onTextUpdate(section.id, currentText)
    // 저장 버튼도 동일하게 처리
    setTimeout(() => {
      setEditingSection(null)
    }, 100)
  }
  
  const handleTextChange = (e) => {
    setCurrentText(e.target.value)
  }

  return (
    <div className="section-text">
      {editingSection === section.id ? (
        <div className="text-editing">
          <textarea
            value={currentText}
            onChange={handleTextChange}
            className="edit-textarea"
            rows={3}
            autoFocus
            onKeyDown={handleKeyDown}
            placeholder="대본을 입력하세요."
          />
          <div className="edit-buttons">
            <Button onClick={handleSave} variant="save">
              저장
            </Button>
            <Button onClick={() => setEditingSection(null)} variant="cancel">
              취소
            </Button>
          </div>
        </div>
      ) : (
        <div 
          className="text-display"
          onClick={() => setEditingSection(section.id)}
        >
          <p>{section.text}</p>
          <div className="edit-hint">클릭하여 수정</div>
        </div>
      )}
    </div>
  )
}

export default TextEditor